import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Loader from "Orgs/Loader";
import CheckAccountCredsHOC from "./components/HOC/checkAccountCredsHOC";



//Pages
import LoginPage from "Pages/LoginPage";
import AccountsPage from "Pages/AccountsPage";
import Paymentreceipt from "Pages/Receipt";
import ErrorPage from "./components/atomic/pages/Error/Error";
import TermsOfUse from "Pages/TermsOfUse"
import WpuDetail from "Pages/WpuDetail";
import PortalAccounts from "Pages/PortalAccounts";
import NotFound from "Pages/NotFound";

const App = () => {
	return (<div className="app">
		<Router>
			<div className="main-content">
				<Switch>
					<Route exact path="/" component={LoginPage} />
					<Route path="/accounts" component={CheckAccountCredsHOC(AccountsPage)} />
					<Route path="/portalAccounts/:billing/:zipCode" component={PortalAccounts} />
					<Route path="/receipt" component={Paymentreceipt} />
					<Route path="/error" component={ErrorPage} />
					<Route path="/terms" component={TermsOfUse} />
					{/* <Route path="/hpu" component={hpu} /> */}
					<Route path="/hpu" render={() => <NotFound hpu = {true}/> } />
					<Route path="/wpu" render={() => <NotFound hpu = {true}/> } />
					{/* <Route path="/wpu" component={wpu} /> */}
					<Route path="/wpudetail" component={WpuDetail} />
					<Route render={() => <NotFound hpu = {false}/> } />
								
					
				</Switch>
			</div>
		</Router>
		<Loader />
	</div>
)}

export default App;



// WEBPACK FOOTER //
// ./src/App.js